import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import ImageSliderMobile from './imageSliderMobile';
import { Typography, useMediaQuery } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { DOMAIN } from '../../config';
import theme from '../../styles/theme';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: "95%",
  height: "90vh",
  backgroundColor: 'rgba(255, 255, 255, 0.12)', // 半透明白色
  backdropFilter: 'blur(24px)',                 // 毛玻璃效果
  boxShadow: '0 24px 48px rgba(0,0,0,0.18)',
  borderRadius: "16px",
  p: 0,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  overflow: "hidden",
  '& img': {
    width: '100%',
    height: 'auto',
    objectFit: 'contain',
    borderRadius: 0,   // 无圆角边框
    boxShadow: 'none', // 不使用图片阴影
  },
};

export default function ImageSwpiderModal({ open = false, setOpen, imgIndex, setImgIndex, medias }) {
  const matches = useMediaQuery(theme.breakpoints.down("md"));

  const handleClose = () => {
    if (matches) setOpen(false);
  };

  const handleCloseIcon = () => setOpen(false);

  const images = medias.map(item => `${DOMAIN}miniapp/${item.fileid}.jpg`);

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style} onClick={handleClose}>
        {/* 关闭按钮 */}
        <Box
          sx={{
            position: "absolute",
            top: 20,
            right: 20,
            zIndex: 999,
          }}
        >
          <CloseIcon
            onClick={handleCloseIcon}
            sx={{
              fontSize: matches ? 30 : 42,
              background: 'linear-gradient(135deg, #ff8eff, #8ed1ff)',
              borderRadius: "50%",
              padding: 1,
              color: "#fff",
              cursor: 'pointer',
              boxShadow: '0 6px 12px rgba(0,0,0,0.2)',
              transition: 'transform 0.2s ease',
              '&:hover': {
                transform: 'scale(1.1)',
              }
            }}
          />
        </Box>

        {/* 图片计数器 */}
        <Box
          sx={{
            position: "absolute",
            bottom: 30,
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 999,
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontSize: 16,
              background: 'rgba(255, 255, 255, 0.18)', // 更透明
              color: '#000',
              px: 2,
              py: 0.5,
              borderRadius: '12px',
              backdropFilter: 'blur(16px)',
              boxShadow: '0 4px 12px rgba(0,0,0,0.12)',
            }}
          >
            {imgIndex==0?1:imgIndex}/{images.length}
          </Typography>
        </Box>

        {/* 图片轮播 */}
        <ImageSliderMobile
          images={images}
          setOpen={setOpen}
          imgIndex={imgIndex}
          setImgIndex={setImgIndex}
          matches={matches}
        />
      </Box>
    </Modal>
  );
}
